import React from 'react';
import PropTypes from 'prop-types';
import './CommentIcon.css';

function CommentIcon({ filled }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="515 1104 15 15"
      className="icon-comment"
    >
      <path
        id="Path_3584"
        className={filled ? 'filled' : ''}
        data-name="Path 3584"
        d="M15,1.5A1.5,1.5,0,0,0,13.5,0H1.5A1.5,1.5,0,0,0,0,1.5v9A1.5,1.5,0,0,0,1.5,12H12l3,3ZM12,9H3V7.5h9Zm0-2.25H3V5.25h9ZM12,4.5H3V3h9Z"
        transform="translate(515 1104)"
      />
    </svg>
  );
}

CommentIcon.propTypes = {
  filled: PropTypes.bool
};

export default CommentIcon;



// WEBPACK FOOTER //
// ./src/components/Icon/CommentIcon/index.js